import React from "react";
import modernAnglesLogo from "../../../../assets/images/MA_Logo_New_2.svg";

const GOOGLE_REVIEW_URL = "https://search.google.com/local/writereview?placeid=ChIJf5SfSzy3wokRy8ndykyNEt0";

class GoogleReviewModal extends React.Component {
  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = 'unset';
  }

  render() {
    return (
      <div className="modal-background" onClick={() => this.props.onClose()}>
        <div className="orderpreviewModal reviewModal googleReviewModal" onClick={e => e.stopPropagation()}>
          <div className="orderPreviewModalComponent">
            <div className="googleReviewModalHeader">
              <img src={modernAnglesLogo} className="googleReviewModalLogo" alt="Modern Angles" />
              <span className="googleReviewModalHeaderText">GOOGLE REVIEW</span>
            </div>
            <h2 className="googleReviewModalHeading">
              Leave a Google review &amp; get $10 toward your next shoot
            </h2>
            <p className="googleReviewModalSubtext">
              Thanks for your time — your feedback means a lot to us.
            </p>
            <a
              href={GOOGLE_REVIEW_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="googleReviewStartButton"
              onClick={() => this.props.onClose()}
            >
              Start Review &raquo;
            </a>
            <div className="googleReviewModalDismiss" onClick={() => this.props.onClose()}>
              No thanks
            </div>
          </div>
          <div className="modalMobilePushup"></div>
        </div>
      </div>
    );
  }
}

export default GoogleReviewModal;
